import React from "react";

import Form from "antd/es/form";
import { useIntl } from "react-intl";

import Card from "./Card";
import Header from "./Header";

interface Props {}

const TeamMentions: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <Card>
      <Form.Item name="teamMentions" valuePropName="checked">
        <Header
          description={intl.formatMessage({
            id: "settings.notifications.teamMentions.text",
            defaultMessage:
              "Get notified every time someone mentions your team in a Note or Activity description.",
            description: "Text of settings notifications team mentions card",
          })}
          title={intl.formatMessage({
            id: "settings.notifications.teamMentions.title",
            defaultMessage: "Team Mentions",
            description: "Title of settings notifications team mentions card",
          })}
        />
      </Form.Item>
    </Card>
  );
};

export default TeamMentions;
